<template>
  <div>
    <TopHeader code="train" />

    <section class="uc-banner240">
      <div class="con">
        <h2>师徒系统</h2>
        <div class="line"></div>
        <div class="txt">
          一对一、一对多辅导，把控徒弟培训整体进度，制定“定制化”培养方案，促进员工个人能力成长
        </div>
      </div>
    </section>

    <section class="container-fluid uc-learnMapList uc-bg">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="title">选择意向师傅</div>
          </div>
        </div>
        <div class="row list">
          <div class="content-empty" v-if="list.length == 0">
            <div class="emptyimg-box"></div>
            <p>暂无相关内容</p>
          </div>
          <div
            v-for="(item, index) in list"
            :key="index"
            class="col-24 col-sm-8"
          >
            <a
              href="javascript:void(0);"
              @click="handleClick(item)"
              :title="`点选 ${item.first_name} 为意向师傅`"
            >
              <div class="item">
                <img
                  :src="item.avatar"
                  :alt="item.first_name"
                  style="width:175px;height:175px;border-radius:100%;margin:0 auto;"
                  onerror="this.src=document.getElementById('avatar').src;this.onerror=null;"
                />
                <div class="more" style="line-height:80px;">
                  {{ item.first_name }}
                </div>
                <div class="txt">
                  {{ item.description }}
                </div>
              </div>
              <span
                class="uc-tag orange"
                style="width:100px;"
                v-if="item.is_will_master > 0"
                >✔️ 意向师傅</span
              >
            </a>
          </div>
        </div>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'ShituWillMaster',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getShituWillMasters();
    },
    async getShituWillMasters() {
      const response = await this.$api.shitu.getShituWillMasters();
      this.list = response.data.data;
    },
    handleClick(item) {
      this.$confirm(
        `确认选择【${item.first_name}】为您的意向师傅, 是否继续?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.$api.shitu
            .editShituRelation({ master_id: item.master_id })
            .then((response) => {
              if (response.data.code === 200) {
                this.initData();
                this.$message.success(response.data.message);
              } else {
                this.$message.warning(response.data.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: `已取消选择 ${item.first_name} 为意向师傅！`,
          });
        });
    },
  },
};
</script>
